import { writable } from 'svelte/store';
import store from 'store';

export const session = writable({
  loggedIn: store.get('token') || false,
  token: store.get('token')
});
